// Application constants

// Timing constants (in milliseconds)
export const TIMINGS = {
  SUCCESS_MESSAGE_DURATION: 10000,  // 10 seconds
  API_TIMEOUT: 30000,               // 30 seconds
  WEBSOCKET_PING_INTERVAL: 20000,   // 20 seconds
  WEBSOCKET_UPDATE_INTERVAL: 2000,  // 2 seconds
  WEBSOCKET_QUERY_TIMEOUT: 5000,    // 5 seconds
  RECONNECT_MAX_DELAY: 10000,       // 10 seconds
  FILE_POLL_INTERVAL: 5000,         // 5 seconds for file list refresh
  METRICS_REFRESH_INTERVAL: 30000,  // 30 seconds for metrics refresh
};

// Limits
export const LIMITS = {
  MAX_REQUIREMENTS: 3000,           // Maximum requirements per job
  MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB
  MAX_RECONNECT_ATTEMPTS: 5,        // WebSocket reconnection attempts
  MIN_PASSWORD_LENGTH: 8,           // Minimum password length
};

// File types
export const FILE_TYPES = {
  REQUIREMENTS: 'requirements',
  RULES: 'rules',
  REPORTS: 'reports',
};

// Requirement file types
export const REQUIREMENT_FILE_TYPES = {
  PLM: { label: 'PLM', description: 'Standard INCOSE format' },
  FUSA: { label: 'FUSA', description: 'Medini FuSa format' },
  FUSA_FSC: { label: 'FUSA FSC', description: 'FuSa FSC format' },
  FUSA_OLD: { label: 'FUSA (Legacy)', description: 'Legacy FuSa format' },
  TSC_L2: { label: 'TSC L2', description: 'Technical Safety Concept Level 2 format' },
  DOCX: { label: 'DOCX', description: 'Word document format' },
  SFD: { label: 'SFD', description: 'ELM/DOORS narrative Word document (Functional Requirements section only)' },
};

// Error messages
export const ERROR_MESSAGES = {
  GENERIC: 'An error occurred. Please try again.',
  FILE_TOO_LARGE: 'File size exceeds the maximum limit of 50MB',
  NO_REQUIREMENTS_FILE: 'Please select a requirements file',
  NO_RULES_FILE: 'Please select a rules file',
  INVALID_FILE_TYPE: 'Invalid file type. Please upload an Excel file (.xlsx, .xls)',
  SESSION_EXPIRED: 'Your session has expired. Please log in again.',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  SERVER_ERROR: 'Server error. Please try again later.',
};

// Success messages
export const SUCCESS_MESSAGES = {
  FILE_UPLOADED: 'File uploaded successfully!',
  JOB_SUBMITTED: 'Job submitted successfully!',
  JOB_CANCELLED: 'Job cancelled successfully',
  FILE_DELETED: 'File deleted successfully',
};

// Default configurations
export const DEFAULT_CONFIG = {
  MODEL: 'us.anthropic.claude-3-7-sonnet-20250219-v1:0',
  MAX_TRIES: 3,
  MAX_TOKENS: 4096,
  TEMPERATURE: 0,
  TOP_P: 1.0,
};

// Regex patterns
export const PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  USER_ID: /^[A-Z0-9]{7}$/i,  // Stellantis user ID format
  EXCEL_FILE: /\.(xlsx?|xls)$/i,
};